import { render, staticRenderFns } from "./clipper-basic.vue?vue&type=template&id=45869ad8&scoped=true&"
import script from "./clipper-basic.vue?vue&type=script&lang=js&"
export * from "./clipper-basic.vue?vue&type=script&lang=js&"
import style0 from "./clipper-basic.vue?vue&type=style&index=0&id=45869ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45869ad8",
  null
  
)

export default component.exports